import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['finance', 'expense-categories'];

export function useExpenseCategories() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/finance/expense-categories');
      return data?.categories || data?.data || data || [];
    },
    staleTime: 60_000
  });
}

export function useCreateExpenseCategory() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/finance/expense-categories', body).then((r) => r.data),
    successMessage: 'تم إنشاء الفئة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useUpdateExpenseCategory() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/finance/expense-categories/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ الفئة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeleteExpenseCategory() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/finance/expense-categories/${id}`).then((r) => r.data),
    successMessage: 'تم حذف الفئة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
